'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _auth = require('redux/modules/auth');

var _uploads = require('helpers/uploads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _cloud = require('redux/modules/cloud');

var cloudActions = _interopRequireWildcard(_cloud);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendUploadArea.scss');
var uploadImg = require('./upload-row.png');
var desktopImg = require('assets/desktop-icon.png');

var QuickSendUploadArea = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    mediaList: state.project.mediaListData,
    submittedCloudFiles: state.project.submittedCloudFiles,
    submittedMediaFiles: state.project.submittedMediaFiles
  };
}, (0, _extends3.default)({}, projectActions, cloudActions, { logout: _auth.logout })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendUploadArea, _Component);

  function QuickSendUploadArea() {
    var _ref;

    (0, _classCallCheck3.default)(this, QuickSendUploadArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendUploadArea.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea)).call.apply(_ref, [this].concat(args)));

    _this._uploaderOnSubmitted = function (id) {
      _this.props.submitMediaFile(id);
    };

    _this._uploaderOnComplete = function (id, name, resp) {
      var code = resp.code,
          msg = resp.msg;
      var projectId = _this.props.projectId;

      if (code === 1) {
        return _this.props.logout();
      }
      if (code && msg) {
        _toastr2.default.error(msg);
      }
      var data = (0, _get7.default)(resp, 'data[0]');
      if (data) {
        _this.props.addMedia((0, _extends3.default)({}, data, { uploaderId: id }), projectId);
      }
    };

    _this._uploaderStatusChange = function (id, oldStatus, newStatus) {
      var _this$props = _this.props,
          projectId = _this$props.projectId,
          addFailedMedia = _this$props.addFailedMedia;

      var isFailed = (0, _uploads.isUploadFailed)(newStatus);
      if (isFailed) {
        addFailedMedia({ uploaderId: id }, projectId);
      }
    };

    _this._mountUploader = function () {
      var FineUploaderTraditional = require('components/FineUploader/traditional');
      var projectId = _this.props.projectId;

      var postParams = { projectId: projectId };

      _this.uploader = new FineUploaderTraditional({
        request: { params: (0, _extends3.default)({}, postParams, { replacedId: 0, part: 0 }) },
        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } },
        validation: {
          acceptFiles: (0, _uploads.getUploaderAcceptableFormats)('audio'),
          allowedExtensions: _config2.default.app.uploaderSupportedFormats.audio
        }
      });

      _this.uploader.on('submitted', _this._uploaderOnSubmitted);
      _this.uploader.on('complete', _this._uploaderOnComplete);
      _this.uploader.on('statusChange', _this._uploaderStatusChange);
    };

    _this._unMountUploader = function () {
      _this.uploader.off('submitted', _this._uploaderOnSubmitted);
      _this.uploader.off('complete', _this._uploaderOnComplete);
      _this.uploader.off('statusChange', _this._uploaderStatusChange);
      _this.uploader.methods.cancelAll();
      _this.uploader = null;
    };

    _this.uploader = null;
    return _this;
  }

  (0, _createClass3.default)(QuickSendUploadArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get5.default)(QuickSendUploadArea.prototype.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea.prototype), 'componentDidMount', this).call(this, this._mountUploader);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get5.default)(QuickSendUploadArea.prototype.__proto__ || (0, _getPrototypeOf2.default)(QuickSendUploadArea.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
    }
  }, {
    key: 'onCloudUpload',
    value: function onCloudUpload(cloudFile) {
      var _props = this.props,
          addMedia = _props.addMedia,
          projectId = _props.projectId;

      if (cloudFile) {
        addMedia(cloudFile, projectId);
      }
    }
  }, {
    key: 'deleteItem',
    value: function deleteItem(uploaderId) {
      var _props2 = this.props,
          projectId = _props2.projectId,
          mediaList = _props2.mediaList,
          deleteMedia = _props2.deleteMedia;

      var media = (0, _find4.default)(mediaList, { uploaderId: uploaderId });
      if (media) {
        return deleteMedia(projectId, media.id, uploaderId).promise;
      }
    }
  }, {
    key: 'deleteCloudItem',
    value: function deleteCloudItem(cloudFile) {
      var _props3 = this.props,
          projectId = _props3.projectId,
          deleteCloudFile = _props3.deleteCloudFile;

      var id = (0, _get7.default)(cloudFile, 'metadata.id');
      return deleteCloudFile(projectId, id).promise;
    }
  }, {
    key: 'cancelItem',
    value: function cancelItem(id) {
      this.props.deleteMediaFile(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          t = _props4.t,
          submittedMediaFiles = _props4.submittedMediaFiles,
          submittedCloudFiles = _props4.submittedCloudFiles,
          projectId = _props4.projectId,
          className = _props4.className;

      var supportedFormats = (0, _uploads.getUploaderAcceptableFormats)('audio');
      var supportedFileTypes = _config2.default.app.uploaderSupportedFormats.audio;
      var uploader = this.uploader;

      var isMediaFiles = !(0, _isEmpty4.default)(submittedMediaFiles);
      var isCloudFiles = !(0, _isEmpty4.default)(submittedCloudFiles);

      if (!uploader) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _components.UploadArea,
          {
            uploader: uploader,
            hideHeader: true,
            clickable: true,
            accept: supportedFormats
          },
          _react2.default.createElement(
            'div',
            { className: styles.uploadHint },
            _react2.default.createElement(
              'div',
              { className: 'padding-5' },
              _react2.default.createElement('img', { src: uploadImg, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Drag & Drop files to upload or press to select')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.cloudButtons },
          _react2.default.createElement(
            _components.FileInput,
            { uploader: uploader, className: styles.computerButton, accept: supportedFormats, multiple: true },
            _react2.default.createElement(
              'span',
              { className: 'btn btn-clear' },
              _react2.default.createElement(
                _components.Tooltip,
                { placement: 'bottom', title: t('Upload from computer') },
                _react2.default.createElement('img', { src: desktopImg, alt: '' })
              )
            )
          ),
          _react2.default.createElement(_components.CloudUploader, { projectId: projectId, onCloudUpload: this.onCloudUpload, part: 0, fileTypes: supportedFileTypes })
        ),
        isMediaFiles && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'hint small' },
            t('Files from the computer')
          ),
          submittedMediaFiles.map(function (id) {
            return _react2.default.createElement(_components.UploaderItem, {
              className: 'margin-bottom-10',
              key: id,
              id: id,
              uploader: uploader,
              showOnSuccess: true,
              cancelable: true,
              deletable: true,
              showStatusIcon: true,
              onCancel: function onCancel() {
                return _this2.cancelItem(id);
              },
              onDelete: function onDelete() {
                return _this2.deleteItem(id);
              }
            });
          })
        ),
        isCloudFiles && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'hint small' },
            t('Files from the cloud services')
          ),
          submittedCloudFiles.map(function (cloudFile) {
            return _react2.default.createElement(_components.CloudUploaderItem, {
              key: cloudFile.uniqId,
              showOnSuccess: true,
              deletable: true,
              onDelete: function onDelete() {
                return _this2.deleteCloudItem(cloudFile);
              },
              cloudFile: cloudFile
            });
          })
        ),
        isMediaFiles && _react2.default.createElement(_components.TotalProgress, { uploader: uploader })
      );
    }
  }]);
  return QuickSendUploadArea;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addFailedMedia: _propTypes2.default.func,
  addMedia: _propTypes2.default.func,
  className: _propTypes2.default.string,
  deleteCloudFile: _propTypes2.default.func,
  deleteMedia: _propTypes2.default.func,
  deleteMediaFile: _propTypes2.default.func,
  logout: _propTypes2.default.func,
  mediaList: _propTypes2.default.array,
  projectId: _propTypes2.default.number,
  submitMediaFile: _propTypes2.default.func,
  submittedCloudFiles: _propTypes2.default.array,
  submittedMediaFiles: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCloudUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCloudUpload'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendUploadArea;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendUploadArea.js
// module id = 2078
// module chunks = 1